import { render } from "./SidebarMenu.vue?vue&type=template&id=6d68ffba&scoped=true&ts=true"
import script from "./SidebarMenu.vue?vue&type=script&lang=ts"
export * from "./SidebarMenu.vue?vue&type=script&lang=ts"

import "./SidebarMenu.vue?vue&type=style&index=0&id=6d68ffba&scoped=true&lang=css"

import exportComponent from "/home/tecnonet/galidancia_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d68ffba"]])

export default __exports__